export default __webpack_public_path__ + "static/Equitrip-41db5739d048ae110d99b83aa2ce50ee.webp";